import { useEffect } from 'react'
import SiteHeader from '@/components/SiteHeader'
import SiteFooter from '@/components/SiteFooter'
import Founder from '@/components/landing/Founder'
import Seo from '@/components/Seo'
import { useScrollReveal } from '@/hooks/useScrollReveal'
import './landing.css'

export default function MissionPage() {
  useScrollReveal()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="landing mission-page">
      <Seo
        title="Mission | Pelvia"
        description="Meet the physician behind Pelvia, and read our founder Dr. Tiger Bawa’s letter on why he built a platform to end the seven-year wait."
        path="/mission"
        image="/static/og/mission.png"
      />
      <SiteHeader />
      <Founder />
      <SiteFooter />
    </div>
  )
}
